import styled from "styled-components";
export const SelectBox = styled.div`
  position: relative;
  width: 100%;
  && {
    .double & {
      width: calc(50% - 5px);
    }
  }
  &.half {
    width: 40%;
  }
  &.half:nth-of-type(even) {
    width: calc(50% - 5px);
    /* margin-left: 5px; */
  }
  &.half:nth-of-type(odd) {
    width: calc(50% - 5px);
    /* margin-right: 5px; */
  }
  &.custom-select .options {
    display: none;
  }
  &.disabled {
    display: none;
  }
  &.open .options {
    display: inherit;
  }
  &.records {
    width: 150px;
    margin-left: 0;
    margin-right: 0 !important;
  }

  && {
    /* Styles to apply when parent has class shrink */
    .nowrap & {
      margin-right: 10px;
      margin-left: 0;
    }
  }
  button {
    outline: none !important;
    width: 100%;
    border-radius: 10px;
    border: 0px solid silver;
    height: 50px;
    padding-left: 1em;
    font-weight: 700;
    box-shadow: none;
    -webkit-transition: all 0.2s ease-out 0s;
    transition: all 0.2s ease-out 0s;
    color: ${(props) => props.theme.foreground};
    background: #ffffff;
    border: 1px solid #d6e0ff;
    text-align: left;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 0px 0px 0;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &.filter button {
    min-height: 40px;
    height: 40px;
    margin: 4px 0;
    min-width: 150px; 
    border: 0px solid #eef4fe;
    background: ${(props) => props.theme.background};
  }
  &.filter button {
    min-height: 40px;
    height: 40px;
    margin: 4px 0;
    min-width: 100px;
  }
  &.filter {
    margin-right: 0.5em;
  }
  button label {
    display: none;
  }
  button label svg {
    color: green !important;
    transform: rotate(0deg) !important;
  }
  button.has {
    padding-top: 20px;
    white-space: nowrap;
  }
  button.has label {
    position: absolute;
    display: block;
    font-weight: normal;
    top: 5px;
    left: 13px;
    font-size: 12px;
  }
  button.has svg:first-child {
    margin-right: 5px;
  }
  &.filter button.has label {
    font-size: 10px;
    top: 10px;
  }
  &.filter .options {
    top: 31px;
  }
  &.open svg {
    transition: all 0.2s ease-out 0s;
    transform: rotate(180deg);
    color: black;
  }
  button svg {
    margin-left: auto;
    margin-right: 1em;
  }
  .options {
    opacity: 1;
    pointer-events: auto;
    -webkit-transform: scale(1) translateY(0);
    -ms-transform: scale(1) translateY(0);
    transform: scale(1) translateY(0);
    max-height: 250px;
    overflow-y: auto;
    width: 100%;
    background-color: white;
    border: 1px solid rgb(224, 224, 227);
    border-radius: 12px;
    list-style: none;
    padding: inherit;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 1001;
    top: 64px;
    transition: all 1s ease-out 0s;
  }
  &.records .options {
    top: auto;
    bottom: 31px;
  }
  &.records button {
    background: transparent;
    border: 1px solid lightgray;
  }
  .options li.selected {
    background: ${(props) => props.theme.pageBackground};
    background: #eef4fe;
    color: #0f0f0f;
    font-weight: bold;
    border-bottom: 1px solid rgb(224, 224, 227);
  }
  .options li.true {
    background: #eef4fe;
    color: #0f0f0f;
    font-weight: bold;
    border-bottom: 1px solid rgb(224, 224, 227);
    justify-content: left;
    display: flex;
    align-items: flex-start;
  }
  .options svg
  {
    transform: rotate(359deg);
  }
  .options li {
    cursor: pointer;
    border-bottom: 1px solid rgb(224, 224, 227);
    padding: 10px 10px;
    margin: 0 00px;
    flex-direction: column;
    font-size: 14px;
  }
  .options li svg {
    color: ${(props) => props.theme.lightSecForeground};
    margin-left: 10px;
    transform: rotate(0deg);
  }
  .options li:last-child {
    border-bottom: 0px solid rgb(224, 224, 227);
  }
  .options li:hover {
    background: #eef4fe;
    color: #0f0f0f;
  }
  && {
    .timesheet & {
      width: calc(50% - 10px);
    }
  }
  @media screen and (max-width: 768px) {
    &.half:nth-of-type(even) {
      width: 100%;
      margin-left: 0px;
    }
    &.half:nth-of-type(odd) {
      width: 100%;
      margin-right: 0px;
    }
    &.filter {
      width: calc(50% - 7px);
    }
    && {
      .double & {
        width: calc(1000% - 5px);
      }
      .full & {
        &.filter button {
          min-width: 20px;
          width: 70px;
          overflow: hidden;
          min-height: 10px;
          height: 25px;
          margin: 0px 0;
          padding: 10px;
        }
         &.filter label {
          display:none;
        }
      }
    }
    &.records {
      width: 100px;
    }
    &.records button,
    &.filter button {
      min-width: 100px;
      overflow: hidden;
    }
  }
`;
export const Label = styled.label`
  position: absolute;
  pointer-events: none;
  top: 12px;
  left: 14px;
  font-size: 12px;
  transition: all 0.1s ease;
  color: ${(props) => props.theme.foreground};
  &.shrink {
    display: none;
  }
`;
export const Tag = styled.span`
  margin-top: 5px;
  display: flex;
`;
export const TagTitle = styled.span`
  display: flex;
  margin-right: 5px;
  margin-bottom: 5px;
  color: rgb(131, 136, 148);
  &:after {
    content: " :";
  }
`;
export const TagItem = styled.span`
  padding: 0px;
  border-radius: 10px;
  font-weight: 500;
  margin-right: 10px;
  &.image {
    padding: 0;
  }
`;
export const TagBox = styled.label`
  display: flex;
  font-size: 12px;
  flex-direction: row;
  margin-top: 10px;
  &.column {
    flex-direction: column;
    row-gap: 5px;
  }
`;
export const TagData = styled.div`
  display: flex;
  font-size: 12px;
  flex-wrap: wrap;
`;
export const ImgBox = styled.img`
  min-width: 50px;
  max-width: 50px;
  min-height: 50px;
  max-height: 50px;
  border-radius: 12px;
  object-fit: cover;
  margin-right: 10px;
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
`;
export const Button = styled.div`
  border: none;
  padding: 6px 6px;
  margin-right: 8px;
  cursor: pointer;
  font-size: 14px;
  /* white-space: nowrap; */
  border: 1px solid lightgray;
  margin-top: 10px;
  width: fit-content;
  border-radius: 10px;
  &:hover {
    background: white;
  }
`;
export const ButtonSelect = styled.button`
  &:disabled {
    background-color: rgba(239, 239, 239, 0.3)
  }
`;
